import type { HTMLAttributes } from 'react';
import { cn } from '../lib/cn.js';

export type CardProps = HTMLAttributes<HTMLDivElement>;

export function Card({ className, ...rest }: CardProps) {
  return (
    <div
      className={cn('vault-card rounded-2xl border border-outline p-5 sm:p-6', className)}
      {...rest}
    />
  );
}
